import { useCallback } from 'react';

import createQuote from '@/shared/api/orders/quotes/createQuote';
import useRedirectLogin from '@/shared/hooks/useRedirectLogin';
import QuoteResponse from '@/shared/types/order/quotes/quoteResponse.type';
import Response from '@/shared/types/response';

import useCart from '../../components/Cart/hooks/useCart';
import useDefaultSettings from './useDefaultSettings';

type Args = {
  cartState: ReturnType<typeof useCart>;
  defaultSettingsState: ReturnType<typeof useDefaultSettings>;
  handleResponse: (response: Response<QuoteResponse>) => void;
};

const useQuoteCreation = ({
  cartState,
  defaultSettingsState,
  handleResponse,
}: Args) => {
  const redirectLogin = useRedirectLogin();

  const onQuoteCreate = useCallback(async () => {
    const response = await createQuote({
      body: {
        ...defaultSettingsState.defaultSettings,
        quote_type: 'CART',
        products: cartState.productsInCart.map((product) => ({
          product_id: product.product_id,
          variant_id: product.variant_id,
          product_qty: product.product_qty,
        })),
      },
      onUnauthorized: redirectLogin,
    });

    handleResponse(response);
  }, [
    cartState.productsInCart,
    defaultSettingsState.defaultSettings,
    handleResponse,
    redirectLogin,
  ]);

  return { onQuoteCreate };
};

export default useQuoteCreation;
